// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import img1 from "../Assets/tissues1.jpg"
import img2 from "../Assets/tissues2.jpg"
import img3 from "../Assets/tissues3.jpg"





function Tissue() {


    return (
        <div className="min-h-screen bg-white ">


            <div className="flex flex-col items-center  min-h-screen p-4 w-full font-serif">
                <p className="text-3xl text-gray-700 mb-2">
                    The Effect of Strain Rate on the Stress Relaxation of the Pig Dermis
                </p>

                <p className="text-1xl mb-2">
                    The strain rate has a significant influence on the initial stage of stress relaxation; however, the duration of loading does not affect the later stress relaxation of the dermis. Most of the stress relaxation of porcine dermis occurs at the early stage of relaxation (till 540 s), which convey that the short relaxation before closing the large wound reduces the tensile stress on the sutures. Obtained results provide the evidence of strong viscoelastic nature of dermis as the total stress decay is more than 65% of peak stress. The value of equilibrium stress does not depend on the strain rate as stress after 3 h was found almost similar for all the strain rates, which shows the complete elastic response of the dermis. It can be argued that stress-relaxation mechanisms associated with different hierarchies of tissue depend on the loading history. Further, it can be hypothesized that this behavior of skin makes it preventive against the damage: i.e., fast loading rate (traumatic situation) causes higher peak stress but rapid and large stress relaxation which demises the chances of skin damage.
                </p>



                <img
                    src={img1}
                    alt="img1"
                    className="rounded shadow mb-4 mt-4"
                />

                <div className="w-full h-1 border border-black"></div>

                <p className="text-3xl text-gray-700 mb-2 mt-4">
                    Effect of collagen fibre orientation on the Poisson’s ratio and stress relaxation of skin: an ex vivo and in vivo study
                </p>


                <p className="text-1xl mb-2">
                    The results of this study reveal that skin behaves as a compressible material, and its lateral deformation response is direction dependent, which is related to the native configuration of collagen fibers. Furthermore, this study demonstrates that the loss of fluid from the skin is the main driving mechanism of stress relaxation, particularly at small strain levels and the initial stage of stress relaxation. The phenomenon for the later period of stress relaxation, where the increase in Poisson’s ratio becomes almost plateau, can be described by the unfolding of collagen fibrils due to redistribution of the applied strain. Also, the results of this study suggest that the skin should be treated as a biphasic material where the collagen fibers, matrix and IF share the induced stresses. This study also suggests that the short stress relaxation during large wound closure can reduce the excessive stresses on wound edges at the expense of fluid displacement/loss. The findings of this study can be helpful in plastic surgery, wound closure, cosmetic industries and skin graft manufacturing.
                </p>
                <img
                    src={img2}
                    alt="img1"
                    className="rounded shadow mb-4 mt-4" />

                <p className="text-3xl text-gray-700 mb-2 mt-4">
                    Non-Invasive in Vivo Quantification of Directional Dependent Variation in Mechanical Properties for Human Skin
                </p>


                <p className="text-1xl mb-2">
                    The present study developed, validated, and demonstrated a novel full-field measurement suction apparatus that can measure the mechanical stress-strain response for in vivo human skin in all the planar directions by a single test. The developed apparatus applies the axially symmetric loading to measure the apparent toe moduli and apparent linear moduli in all planar directions. The results demonstrated a significant difference in the toe moduli, linear moduli, and orientation of STLs among the subject. Therefore, it is not realistic to generalize the observation of the present study for a large population. Hence, the developed apparatus can be helpful in the medical application for the subject-specific decision-making processes in the treatment, surgery, and tissue engineering by accurate measurement of STLs orientation and mechanical properties. Further, the measurement of direction dependent variation in the linear modulus can help to estimate the directional distribution intensity of collagen fibers. This collagen fiber intensity distribution is required for the calculation of concentration parameters and dispersion parameters in the anisotropic numerical modeling of the in vivo skin. Therefore, this approach may overcome the requirement imaging techniques used to assess collagen fiber dispersion. The imaging technique requires the thin sectioning of the test specimen, which may restrict the collagen dispersion-based numerical modeling of in vivo skin.


                </p>

                <img
                    src={img3}
                    alt="img1"
                    className="rounded shadow mb-4 mt-4" />




            </div>




        </div>
    );
}

export default Tissue;
